import React, { useEffect, useContext, useState } from 'react';
import FavoriteStoresView from './FavoriteStoresView';
import DeliveryAddressView from './DeliveryAddressView';
import { useSelector, useDispatch } from 'react-redux';
import {
  getBulkStoreStatus,
  setStoresUnFavourite,
  resetStores,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import ImageComponent from 'atoms/Image';
import { toast } from 'react-toastify';
import { isEmptyEvery, getDispositionTypeOnAPIFormat } from 'common/utilities/utils';
import SEARCH_STORE_CONSTANTS from '../../../SearchStore/Constants/SearchStoreConstants';
import ADDRESS_STORE_CONSTANTS from './constant';
import { UserOrderContext } from 'context/context';
import tickWhiteToast from '../../../../styles/staticAssets/images/tickWhiteToast.svg';
import { ChannelManager } from 'common/manager';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import SingleArrowback from '../../../../styles/staticAssets/images/SingleArrowback.svg';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';

const AddressStoresContainer = props => {
  const { KM, ADDRESS } = ADDRESS_STORE_CONSTANTS;
  const { STORE_STATUS_OPEN } = SEARCH_STORE_CONSTANTS;
  const { REMOVED_MSG } = TRANSLATE_MAPPING_KEY;

  const dispatch = useDispatch();
  const { userOrderState } = useContext(UserOrderContext);
  const { storesWithStatus, allStores } = useSelector(data => data.storesReducer);
  const { favouriteStores, savedAddresses } = useSelector(data => data.profileReducer);
  const { localized = false } = useSelector(data => data.appStateReducer?.userStatus);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { tenantId = '', storeSearch = {}, driveTime } = tenantReducer;
  const [favStores, setUpdatedStore] = useState([]);
  const [removeFavStore, setRemoveFavorite] = useState(false);
  const dispositionNewProductLandingPage = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const dispositionType =
    dispositionNewProductLandingPage && dispositionNewProductLandingPage.type
      ? getDispositionTypeOnAPIFormat(dispositionNewProductLandingPage.type)
      : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition);

  useEffect(() => {
    if (favStores?.length && tenantId) {
      const storeIds = [];
      favStores.forEach(favStore => {
        storeIds.push({
          storeId: favStore.storeBasic.id,
          channel: ChannelManager.channel,
          service: dispositionType,
        });
      });
      const isFavoritePage = true;
      const favStoreSet = localStorage.getItem('setFav');
      if (!favStoreSet) {
        dispatch(getBulkStoreStatus({ data: storeIds, tenantId, isFavoritePage }));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, favStores?.length]);

  useEffect(() => {
    // componentDidMount events
    window.scrollTo(0, 0);
    dispatch(resetStores());
    return () => {
      dispatch(resetStores());
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (favStores?.length && storesWithStatus?.length) {
      favStores.forEach(favStore => {
        const timings = storesWithStatus.find(obj => obj.storeId === favStore.storeBasic.id);
        if (timings) {
          favStore['summary'] = timings['summary'];
          favStore['isOpen'] = timings['summary']['status']['currentStatus'] === STORE_STATUS_OPEN;
        }
      });
      setUpdatedStore(favStores.filter(obj => obj.summary));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus?.length, favStores?.length]);

  useEffect(() => {
    if (localStorage.getItem('renderComp') && localStorage.getItem('setFav')) {
      localStorage.removeItem('renderComp');
      localStorage.removeItem('setFav');
      dispatch(resetStores());
      setDistance();
    }
  });

  useEffect(() => {
    setDistance();
    if (removeFavStore) {
      toast.dark(
        <div className='img-text-div'>
          <ImageComponent srcFile={tickWhiteToast} /> <span className='text'>{REMOVED_MSG}</span>
        </div>,
        {
          className: 'coupon-toast-position',
          bodyClassName: 'success-coupon-toast',
          hideProgressBar: true,
          position: toast.POSITION.BOTTOM_CENTER,
        },
      );
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favouriteStores.length, removeFavStore]);

  const setDistance = () => {
    const storeInfo = JSON.parse(localStorage.getItem('storeInfo'));
    const defaultAddress = savedAddresses?.length ? savedAddresses.filter(obj => obj.isPrimary) : [];
    const originInfo = storeInfo && localized ? storeInfo : defaultAddress?.length && defaultAddress[0];
    if (originInfo) {
      let distanceMetrix = storeSearch?.distanceMetrics;
      if (distanceMetrix !== KM) {
        distanceMetrix = window.google.maps.UnitSystem.IMPERIAL;
      } else {
        distanceMetrix = window.google.maps.UnitSystem.METRIC;
      }
      const allStoreLocations = favouriteStores.map(favStore => {
        const { latitude, longitude } = favStore.storeBasic?.location || {};
        return { lat: latitude, lng: longitude };
      });
      if (favouriteStores?.length) {
        getDistanceFromGoogleMatrix(
          [{ lat: originInfo?.location?.latitude, lng: originInfo?.location?.longitude }],
          allStoreLocations,
          distanceMetrix,
        );
      } else {
        setUpdatedStore([]);
        setRemoveFavorite(false);
      }
    } else {
      setUpdatedStore(favouriteStores);
      setRemoveFavorite(false);
    }
  };

  const getDistanceFromGoogleMatrix = (startOrigin, destination, distanceMetrix) => {
    let service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [...startOrigin].slice(0, 24),
        destinations: [...destination].slice(0, 24),
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: distanceMetrix,
        avoidHighways: false,
        avoidTolls: false,
      },
      collectAllDistance,
    );
  };

  const collectAllDistance = (response, status) => {
    let allStoreWithDistanceInfo = [];

    let allStoreDistance = [];
    allStoreDistance = response?.rows && response.rows[0].elements.map(storeDistance => storeDistance);
    allStoreWithDistanceInfo = favouriteStores.map((store, index) => {
      return { ...store, ...allStoreDistance[index] };
    });

    setUpdatedStore(allStoreWithDistanceInfo);
    setRemoveFavorite(false);
  };

  const removeFromFavoriteHandler = id => {
    const { customerId } = AuthManager.getInstance();
    dispatch(
      setStoresUnFavourite({
        tenantId: tenantId,
        customerId: customerId,
        storeId: id,
        dispatch: 'dispatch',
      }),
    );
    setRemoveFavorite(true);
  };

  return (
    <div className='addresses-and-stores-container'>
      <div className='my-delivery-addresses-header-mobile'>
        <img className='backArrow-account-setting' onClick={() => props.updateMenu('')} src={SingleArrowback} alt='Back Arrow' />
        <span className='account-setting-text-header'>{translateWithI18Next(ADDRESS)}</span>
      </div>
      {(favStores?.length > 0 || storesWithStatus?.length > 0) && (
        <FavoriteStoresView
          data-testid='favStore-list'
          removeFromFavoriteHandler={removeFromFavoriteHandler}
          localized={localized}
          history={props.history}
          storesReducer={storesWithStatus}
          favouriteStores={favStores}
          isMobile={props.isMobile}
        />
      )}
      {/* {savedAddresses?.length > 0 && ( */}
      <DeliveryAddressView
        storeSearch={storeSearch}
        savedAddresses={savedAddresses}
        isMobile={props.isMobile}
        tenantId={tenantId}
        driveTime={driveTime}
        allStores={allStores}
        updateMenu={props.updateMenu}
      />
      {/* )} */}
    </div>
  );
};
export default AddressStoresContainer;
